import angular from 'angular';

angular.module('AaApp.Opp').constant('priceSetToOptions', {
    empty: "N",
    totalPrice: "P",
    msrp: "M"
});